/* tslint:disable */

/**
 */
export class User {
    USER_ENERGY?: number;
    ID_USER?: number;
    CODE_LANGUE?: number;
    ID_CALC_PARAMSDEF?: number;
    ID_TEMP_RECORD_PTS_DEF?: number;
    USERNAM?: string;
    USERPRIO?: number;
    TRACE_LEVEL?: number;
    ID_MONETARY_CURRENCY?: number;
    USER_CONSTRUCTOR?: string;
    USER_FAMILY?: number;
    USER_ORIGINE?: number;
    USER_PROCESS?: number;
    USER_MODEL?: number;
    USERMAIL?: string;
    API_TOKEN?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/user.ts